<template>
    <div id="content" class="full no-padding">
        <div class="bloc">

            <div class="col-lg-12 text-right" style="float: left;" v-if="(request.lnk != null && request.lnk != false && request.lnk != '')">
                <button class="btn btnMerged" @click="openArrete()" style="margin-right: 5px;"> <font-awesome-icon icon="file-alt"></font-awesome-icon> Arrêté</button>
            </div>

            <div class="col-lg-12" style="float: left;">
                <h4>Carte: </h4>
                <maps></maps>
            </div>
            <div class="col-lg-12" style="float: left;">
                <div class="ecran bloc col-lg-12">
                    <h5>Informations générales</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="6"><b>Date de la demande: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{request.date_demande}}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Numéro du dossier: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{request.ident}}</b-col>
                        </b-row>
                    </div>
                </div>

                <div class="ecran bloc col-lg-12">
                    <h5>Informations du demandeur</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="6"><b>Nom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.nom"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Prénom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.prenom"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Adresse: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.adresse"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Code postal: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.code_postal"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Commune: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.ville"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Téléphone: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.telephone"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>E-mail: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.email"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Code Siret: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.siret"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Raison sociale: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.raison_sociale"></b-input></b-col>
                        </b-row>
                    </div>
                </div>

                <div v-if="request.marker==='odp_demenagement' || request.marker==='odp_travaux'" class="ecran bloc col-lg-12">
                    <h5>Informations du bénéficiaire</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="6"><b>Nom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.nom_beneficiaire"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Prénom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.prenom_beneficiaire"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Adresse: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.adresse_beneficiaire"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Téléphone: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.telephone_beneficiaire"></b-input></b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>E-mail: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.email_beneficiaire"></b-input></b-col>
                        </b-row>
                    </div>
                </div>

                <travaux v-if="request.marker === 'odp_travaux'" :id="request.id"></travaux>
                <stationnement v-if="request.marker === 'odp_stationnement'" :id="request.id"></stationnement>
                <demenagement v-if="request.marker === 'odp_demenagement'" :id="request.id"></demenagement>
            </div>

            <div class="col-lg-12 text-center" style="float: left;" v-if="(isDisabled && isHourDisabled)">
                <button v-if="!isExtended && request.etat >= 2" @click="extendRequest()" class="btn btn-primary" style="margin-right: 5px;">Prolonger la demande</button>
                <button  v-if="request.etat < 2" @click="editRequest()" class="btn btn-primary" style="margin-left: 5px;">Modifier la demande</button>
            </div>

            <div class="col-lg-12 text-center" style="float: left;" v-if="!(isDisabled && isHourDisabled)">
                <button @click="reset()" class="btn btn-primary" style="margin-right: 5px;">Annuler</button>
                <button v-if="!isHourDisabled" @click="validExtend()" class="btn btn-green" style="margin-left: 5px;">Valider</button>
                <button v-if="!isDisabled" @click="valid()" class="btn btn-green" style="margin-left: 5px;">Valider</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuex from "vuex";
    import router from "../../router/index.js";
    import Vue from "vue";
    import Maps from "../../components/Maps";
    import Travaux from "@/views/Detail/Travaux";
    import Stationnement from "@/views/Detail/Stationnement";
    import Demenagement from "@/views/Detail/Demenagement";

    export default {
        name: "Detail",
        components: {
            Demenagement,
            Stationnement,
            Travaux,
            maps: Maps
        },
        data() {
            return {
                requestBeforeEdit: {},
                isExtended: false
            }
        },
        computed: {
            request: {
                get() {
                    return this.currentDemande;
                },
                set(value) {
                    this.setDemande(value);
                }
            },
            ...Vuex.mapGetters('Demande', ['currentDemande']),
            ...Vuex.mapGetters('Application', ['isHourDisabled', 'isDisabled'])
        },
        methods: {
            openArrete() {
                window.open(this.request.lnk);
            },
            extendRequest() {
                this.setIsHourDisabled(false);
            },
            editRequest() {
                this.requestBeforeEdit = this.request;
                this.setIsDisabled(false);
            },
            valid() {
                this.setIsHourDisabled(true);
                this.setIsDisabled(true);
                this.updateDemande(this.request);
            },
            validExtend() {
                this.duplicateDemande(this.request);
                this.isExtended = true;
            },
            reset() {
                this.setIsHourDisabled(true);
                this.setIsDisabled(true);

                this.request = this.requestBeforeEdit;
            },
            ...Vuex.mapActions('Application', ['setIsHourDisabled', 'setIsDisabled']),
            ...Vuex.mapActions('Demande', ["setDemande", "updateDemande", "duplicateDemande"])
        }
    }
</script>

<style scoped>

</style>